package twist.mena.sports.admin

import androidx.compose.runtime.*
import kotlinx.browser.localStorage
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.renderComposable
import twist.mena.sports.admin.api.AdminAdsApi
import twist.mena.sports.admin.api.AdminNotificationSettingsApi
import twist.mena.sports.admin.api.AdminApiClient
import twist.mena.sports.admin.api.AdminLegacyCrudApi
import twist.mena.sports.admin.components.AdminLayout
import twist.mena.sports.admin.screens.*
import twist.mena.sports.admin.state.NavState
import twist.mena.sports.admin.state.Screen
import twist.mena.sports.admin.theme.AppThemeProvider

fun main() {
    val baseUrl = js("window.ADMIN_API_BASE_URL || ''") as String
    val apiClient = AdminApiClient(baseUrl = baseUrl)
    val legacyCrudApi = AdminLegacyCrudApi(baseUrl = baseUrl)
    val adsApi = AdminAdsApi(baseUrl = baseUrl)
    val notificationSettingsApi = AdminNotificationSettingsApi(baseUrl = baseUrl)

    renderComposable(rootElementId = "root") {
        var isDark by remember {
            mutableStateOf(localStorage.getItem("admin_theme") != "light")
        }
        var showPreview by remember { mutableStateOf(false) }

        AppThemeProvider(isDark = isDark) {
            Style {
                "*, *::before, *::after" {
                    property("box-sizing", "border-box")
                    property("margin", "0")
                    property("padding", "0")
                }
                "body" {
                    property("font-family", "'Cairo', sans-serif")
                }
            }

            val toggleTheme: () -> Unit = {
                isDark = !isDark
                localStorage.setItem("admin_theme", if (isDark) "dark" else "light")
            }
            val togglePreview: () -> Unit = { showPreview = !showPreview }

            when (NavState.currentScreen) {
                Screen.LOGIN -> LoginScreen(apiClient)
                Screen.VERIFY -> VerifyScreen(apiClient)
                Screen.OVERVIEW -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    OverviewScreen(apiClient)
                }
                Screen.TEAMS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    TeamsScreen(apiClient)
                }
                Screen.LEAGUES -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    LeaguesScreen(apiClient)
                }
                Screen.FIXTURES -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    FixturesScreen(apiClient)
                }
                Screen.PLAYERS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    PlayersScreen(apiClient)
                }
                Screen.SYNC_RUNS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    SyncRunsScreen(apiClient)
                }
                Screen.NOTIFICATIONS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    NotificationsScreen(apiClient, notificationSettingsApi)
                }
                Screen.ANALYTICS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    AnalyticsScreen(apiClient)
                }
                Screen.ADS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    AdsScreen(adsApi)
                }
                Screen.AUTOMATION_TESTS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    AutomationTestsScreen(apiClient)
                }
                Screen.API_DOCS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    ApiDocsScreen()
                }
                Screen.LEGACY_API_DOCS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    LegacyApiDocsScreen()
                }
                Screen.LEGACY_TEAMS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    LegacyCrudTeamsScreen(legacyCrudApi)
                }
                Screen.LEGACY_LEAGUES -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    LegacyCrudLeaguesScreen(legacyCrudApi)
                }
                Screen.LEGACY_PLAYERS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    LegacyCrudPlayersScreen(legacyCrudApi)
                }
                Screen.ENTITY_MAPPINGS -> AdminLayout(isDark, toggleTheme, showPreview, togglePreview) {
                    EntityMappingsScreen(apiClient)
                }
            }
        }
    }
}
